import { AtSign, Globe, Mail, MessageCircle, MessagesSquare, Users, type LucideIcon } from "lucide-react";

import { statusBadgeClass } from "@/components/StatusBadge";
import type { CanalDaConversa } from "@/lib/types";
import { cn } from "@/lib/utils";

/**
 * TUT-491 — o selo do canal no item da caixa única. O canal é um selo, não uma
 * aba (Front, Intercom, Missive): o selo suave da casa (`statusBadgeClass`,
 * Lumen) no tom neutro, com o ícone do canal no lugar do ponto. Canal não é
 * situação, então nenhum canal toma a cor de "atenção" ou "crítico".
 */
export const ICONE_DO_CANAL: Record<CanalDaConversa, LucideIcon> = {
  whatsapp: MessageCircle,
  email: Mail,
  outros: MessagesSquare,
  equipe: Users,
  portal: Globe,
};

export function SeloDoCanal({
  canal,
  rotulo,
  className,
}: {
  canal: CanalDaConversa;
  rotulo: string;
  className?: string;
}) {
  const Icone = ICONE_DO_CANAL[canal];
  return (
    <span data-selo-do-canal={canal} className={cn(statusBadgeClass("neutral"), "before:hidden", className)}>
      <Icone aria-hidden="true" className="size-3" />
      {rotulo}
    </span>
  );
}

/** O "@" do item: alguém mencionou você nesta conversa (C3). */
export function SeloDeMencao() {
  return (
    <span data-selo-de-mencao className={cn(statusBadgeClass("info"), "before:hidden")}>
      <AtSign aria-hidden="true" className="size-3" />
      Mencionou você
    </span>
  );
}
